import { render, staticRenderFns } from "./BillingsPendingManualConfig.vue?vue&type=template&id=45064950&"
import script from "./BillingsPendingManualConfig.vue?vue&type=script&lang=js&"
export * from "./BillingsPendingManualConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports